import { Pane, Heading, Paragraph, UnorderedList, ListItem, Text, Table, Link } from 'evergreen-ui';

const CookiePolicyPage = () => {
  return (
    <Pane maxWidth={900} marginX="auto" padding={32}>

      <Heading size={900} marginBottom={8}>Cookie Policy</Heading>
      <Paragraph size={300} color="muted" marginBottom={32}>
        Informativa sull'uso di cookie e tecnologie di tracciamento — Versione 2.0 del 14/04/2026
      </Paragraph>
      <Paragraph size={400} marginBottom={32}>
        La presente Cookie Policy va letta congiuntamente alla{' '}
        <Link href="/privacy">Privacy Policy del Sito</Link> alla quale si rinvia per ogni altra
        informazione relativa al trattamento dei dati personali, all'identità del Titolare e ai
        diritti degli interessati.
      </Paragraph>

      {/* ------------------------------------------------------------------ */}
      {/* 1. COSA SONO I COOKIE */}
      {/* ------------------------------------------------------------------ */}
      <Heading size={700} marginBottom={8}>1. Cosa sono i cookie</Heading>
      <Paragraph size={400} marginBottom={12}>
        I cookie sono stringhe di testo che i siti web visitati dall'utente posizionano e archiviano
        all'interno del dispositivo terminale (computer, tablet, smartphone). I software per la
        navigazione (browser) possono memorizzare i cookie e trasmetterli nuovamente ai siti che li
        hanno generati in occasione di una successiva visita, mantenendo così memoria della
        precedente interazione.
      </Paragraph>
      <Paragraph size={400} marginBottom={32}>
        Le informazioni nei cookie possono includere dati personali (come un indirizzo IP o un
        identificativo univoco di sessione) oppure dati non personali (come le preferenze di lingua).
        Ai fini della presente informativa, con il termine «cookie» ci si riferisce anche ad altri
        strumenti di tracciamento analoghi.
      </Paragraph>

      {/* ------------------------------------------------------------------ */}
      {/* 2. DATI DI NAVIGAZIONE */}
      {/* ------------------------------------------------------------------ */}
      <Heading size={700} marginBottom={8}>2. Dati di navigazione</Heading>
      <Paragraph size={400} marginBottom={32}>
        Indipendentemente dall'uso dei cookie, il sito acquisisce automaticamente alcuni dati tecnici
        durante la navigazione: indirizzo IP, tipo di browser, sistema operativo, URL delle pagine
        visitate, orario e durata delle visite. Questi dati sono necessari per il funzionamento
        tecnico del sito e vengono conservati nei log del server per un massimo di 30 giorni, salvo
        necessità di accertamento di reati informatici.
      </Paragraph>

      {/* ------------------------------------------------------------------ */}
      {/* 3. TIPOLOGIE DI COOKIE */}
      {/* ------------------------------------------------------------------ */}
      <Heading size={700} marginBottom={8}>3. Tipologie di cookie</Heading>

      <Heading size={500} marginBottom={8}>3.1 Cookie tecnici</Heading>
      <Paragraph size={400} marginBottom={12}>
        I cookie tecnici sono strettamente necessari per il funzionamento del sito e per consentire
        la navigazione. Senza di essi alcune funzionalità del sito non sarebbero disponibili.{' '}
        <strong>Non è richiesto il preventivo consenso dell'utente</strong> per l'installazione di
        cookie tecnici (art. 122 D.Lgs. 196/2003).
      </Paragraph>

      <Heading size={500} marginBottom={8}>3.2 Cookie analitici</Heading>
      <Paragraph size={400} marginBottom={12}>
        I cookie analitici permettono di raccogliere informazioni aggregate sull'uso del sito
        (numero di visitatori, pagine più visitate, percorsi di navigazione). Se utilizzati da terze
        parti senza adeguato mascheramento dell'IP, richiedono il consenso preventivo.{' '}
        <strong>Il sito di Casa Letizia non utilizza attualmente cookie analitici.</strong>
      </Paragraph>

      <Heading size={500} marginBottom={8}>3.3 Cookie di profilazione e marketing</Heading>
      <Paragraph size={400} marginBottom={32}>
        I cookie di profilazione sono utilizzati per tracciare la navigazione e inviare
        pubblicità mirata. Richiedono sempre il consenso esplicito e preventivo dell'utente.{' '}
        <strong>Il sito di Casa Letizia non utilizza cookie di profilazione o marketing.</strong>
      </Paragraph>

      {/* ------------------------------------------------------------------ */}
      {/* 4. COOKIE UTILIZZATI */}
      {/* ------------------------------------------------------------------ */}
      <Heading size={700} marginBottom={8}>4. Elenco dei cookie utilizzati da questo sito</Heading>
      <Paragraph size={400} marginBottom={16}>
        Il seguente elenco riporta tutti i cookie impostati direttamente da questo sito (prima parte):
      </Paragraph>

      <Pane border="default" borderRadius={4} marginBottom={32} overflow="hidden">
        <Table>
          <Table.Head>
            <Table.TextHeaderCell>Nome</Table.TextHeaderCell>
            <Table.TextHeaderCell>Tipo</Table.TextHeaderCell>
            <Table.TextHeaderCell>Scopo</Table.TextHeaderCell>
            <Table.TextHeaderCell>Durata</Table.TextHeaderCell>
            <Table.TextHeaderCell>Consenso richiesto</Table.TextHeaderCell>
          </Table.Head>
          <Table.Body>
            <Table.Row height="auto" paddingY={8}>
              <Table.Cell><Text size={300} style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>PHPSESSID</Text></Table.Cell>
              <Table.Cell><Text size={300} style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>Tecnico — sessione</Text></Table.Cell>
              <Table.Cell><Text size={300} style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>
                Identifica la sessione PHP dell'utente sul server. Necessario per il corretto funzionamento dell'area riservata e per il mantenimento dell'autenticazione durante la navigazione.
              </Text></Table.Cell>
              <Table.Cell><Text size={300} style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>Sessione (cancellato alla chiusura del browser)</Text></Table.Cell>
              <Table.Cell><Text size={300} style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>No</Text></Table.Cell>
            </Table.Row>
            <Table.Row height="auto" paddingY={8}>
              <Table.Cell><Text size={300} style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>cookie_consent</Text></Table.Cell>
              <Table.Cell><Text size={300} style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>Tecnico — preferenze</Text></Table.Cell>
              <Table.Cell><Text size={300} style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>
                Memorizza la scelta espressa dall'utente in merito all'accettazione o al rifiuto dei cookie, al fine di non ripresentare il banner di consenso ad ogni visita successiva. Contiene un oggetto JSON con le preferenze per categoria (necessari, analitici, marketing, preferenze).
              </Text></Table.Cell>
              <Table.Cell><Text size={300} style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>365 giorni</Text></Table.Cell>
              <Table.Cell><Text size={300} style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>No</Text></Table.Cell>
            </Table.Row>
          </Table.Body>
        </Table>
      </Pane>

      <Paragraph size={300} color="muted" marginBottom={32}>
        Il sito non installa cookie analitici, cookie di profilazione o cookie di marketing. Non
        vengono trasmesse informazioni di navigazione a piattaforme pubblicitarie di terze parti.
      </Paragraph>

      {/* ------------------------------------------------------------------ */}
      {/* 5. SERVIZI DI TERZE PARTI */}
      {/* ------------------------------------------------------------------ */}
      <Heading size={700} marginBottom={8}>5. Servizi di terze parti (Data Processing Services)</Heading>
      <Paragraph size={400} marginBottom={16}>
        Alcune pagine del sito incorporano contenuti forniti da servizi di terze parti. Tali servizi
        possono raccogliere dati di navigazione indipendentemente dalle impostazioni cookie del sito.
      </Paragraph>

      <Pane border="default" borderRadius={4} marginBottom={32} overflow="hidden">
        <Table>
          <Table.Head>
            <Table.TextHeaderCell>Servizio</Table.TextHeaderCell>
            <Table.TextHeaderCell>Scopo</Table.TextHeaderCell>
            <Table.TextHeaderCell>Dati raccolti</Table.TextHeaderCell>
            <Table.TextHeaderCell>Provider</Table.TextHeaderCell>
            <Table.TextHeaderCell>Privacy Policy</Table.TextHeaderCell>
          </Table.Head>
          <Table.Body>
            <Table.Row height="auto" paddingY={8}>
              <Table.Cell><Text size={300} style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>Google Maps (embed)</Text></Table.Cell>
              <Table.Cell><Text size={300} style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>
                Visualizzazione della mappa con la sede della struttura, incorporata nel footer di
                ogni pagina del sito.
              </Text></Table.Cell>
              <Table.Cell><Text size={300} style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>
                Indirizzo IP, tipo di browser e sistema operativo, URL della pagina in cui è
                incorporata la mappa, interazioni dell'utente con la mappa.
              </Text></Table.Cell>
              <Table.Cell><Text size={300} style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>Google LLC / Google Ireland Limited</Text></Table.Cell>
              <Table.Cell><Text size={300} style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>
                <Link
                  href="https://policies.google.com/privacy"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  policies.google.com/privacy
                </Link>
              </Text></Table.Cell>
            </Table.Row>
          </Table.Body>
        </Table>
      </Pane>
      <Paragraph size={400} marginBottom={32}>
        Per il servizio Google Maps, Google LLC ha sede negli USA. Il trasferimento dei dati verso
        gli USA avviene sulla base delle Clausole Contrattuali Standard approvate dalla Commissione
        Europea (art. 46.2 GDPR). Si raccomanda di consultare la{' '}
        <Link href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">
          Privacy Policy di Google
        </Link>{' '}
        per informazioni complete sul trattamento effettuato da Google.
      </Paragraph>

      {/* ------------------------------------------------------------------ */}
      {/* 6. GESTIONE DEL CONSENSO */}
      {/* ------------------------------------------------------------------ */}
      <Heading size={700} marginBottom={8}>6. Gestione e revoca del consenso</Heading>

      <Heading size={500} marginBottom={8}>6.1 Banner cookie del sito</Heading>
      <Paragraph size={400} marginBottom={24}>
        Al primo accesso al sito viene mostrato un banner che permette di esprimere, modificare o
        revocare il consenso all'uso dei cookie non tecnici. Il banner è accessibile in qualsiasi
        momento tramite il link «Impostazioni cookie» presente nel footer del sito. Rifiutare i
        cookie non tecnici non pregiudica la navigazione del sito pubblico. I cookie tecnici sono
        sempre attivi e non possono essere disattivati tramite il banner (possono essere eliminati
        manualmente dal browser, ma questo potrebbe impedire il corretto funzionamento dell'area
        riservata).
      </Paragraph>

      <Heading size={500} marginBottom={8}>6.2 Impostazioni del browser</Heading>
      <Paragraph size={400} marginBottom={12}>
        Puoi in qualsiasi momento cancellare i cookie già installati sul tuo dispositivo o
        modificare le impostazioni del browser per bloccare l'installazione di nuovi cookie. Di
        seguito le istruzioni per i principali browser:
      </Paragraph>
      <UnorderedList marginBottom={32}>
        <ListItem>
          <strong>Google Chrome:</strong>{' '}
          <Link
            href="https://support.google.com/chrome/answer/95647?hl=it"
            target="_blank"
            rel="noopener noreferrer"
          >
            support.google.com/chrome/answer/95647
          </Link>
        </ListItem>
        <ListItem>
          <strong>Mozilla Firefox:</strong>{' '}
          <Link
            href="https://support.mozilla.org/it/kb/Eliminare%20i%20cookie"
            target="_blank"
            rel="noopener noreferrer"
          >
            support.mozilla.org — Eliminare i cookie
          </Link>
        </ListItem>
        <ListItem>
          <strong>Microsoft Edge:</strong>{' '}
          <Link
            href="https://support.microsoft.com/it-it/topic/visualizzare-i-cookie-in-microsoft-edge-a7d95376-f2cd-8e4a-25dc-1de753474879"
            target="_blank"
            rel="noopener noreferrer"
          >
            support.microsoft.com — Cookie in Microsoft Edge
          </Link>
        </ListItem>
        <ListItem>
          <strong>Safari (macOS/iOS):</strong>{' '}
          <Link
            href="https://support.apple.com/it-it/guide/safari/sfri11471/mac"
            target="_blank"
            rel="noopener noreferrer"
          >
            support.apple.com — Safari
          </Link>
        </ListItem>
        <ListItem>
          <strong>Opera:</strong>{' '}
          <Link
            href="https://help.opera.com/en/latest/web-preferences/#cookies"
            target="_blank"
            rel="noopener noreferrer"
          >
            help.opera.com — Web preferences / Cookies
          </Link>
        </ListItem>
      </UnorderedList>
      <Paragraph size={400} marginBottom={32}>
        Attenzione: il blocco o la cancellazione del cookie di sessione <strong>PHPSESSID</strong>{' '}
        impedirà l'accesso all'area riservata del sito. Il blocco del cookie{' '}
        <strong>cookie_consent</strong> comporterà la visualizzazione del banner a ogni visita.
      </Paragraph>

      {/* ------------------------------------------------------------------ */}
      {/* 7. AGGIORNAMENTI */}
      {/* ------------------------------------------------------------------ */}
      <Heading size={700} marginBottom={8}>7. Aggiornamenti della Cookie Policy</Heading>
      <Paragraph size={400} marginBottom={32}>
        La presente Cookie Policy potrà essere aggiornata in seguito a modifiche tecniche del sito,
        all'introduzione di nuovi servizi di terze parti o a variazioni normative. Le modifiche
        saranno pubblicate su questa pagina con aggiornamento della data in calce. In caso di
        modifiche significative alle categorie di cookie utilizzati, il banner di consenso verrà
        ripresentato agli utenti.
      </Paragraph>

      {/* ------------------------------------------------------------------ */}
      {/* FOOTER */}
      {/* ------------------------------------------------------------------ */}
      <Pane borderTop="muted" paddingTop={16}>
        <Text size={300} color="muted">
          Versione 2.0 — Ultimo aggiornamento: 14 aprile 2026 | Base normativa: art. 122 D.Lgs.
          196/2003 — Linee guida sui cookie del Garante (10 giugno 2021) — Reg. (UE) 2016/679
          (GDPR)
        </Text>
      </Pane>
      <Pane marginTop={12}>
        <Text size={300} color="muted">
          Il fornitore del sito web non è responsabile della conformità legale dei contenuti di
          questa pagina, che è redatta e aggiornata a cura del Titolare del trattamento.
        </Text>
      </Pane>

    </Pane>
  );
};

export default CookiePolicyPage;
